import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) =>
  createStyles({
    mb15: {
      'margin-bottom': '15px'
    }
  })
);

export const BottomLink = styled(Link)`
  text-decoration: none;
  color: #4c7cfd;
  margin: 0 auto 5%;
  text-align: center;
  line-height: 17px;
  font-size: 15px;
  font-family: 'TTCommons';
  cursor: pointer;
  font-weight: 600;
  cursor: pointer;
  display: block;
  outline: none;
  &:focus {
    color: #0066ff;
  }
`;
